import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const MarketingUnsubscribe = lazy(() => import("@/pages/MarketingUnsubscribe"));

export const Route = createFileRoute("/marketing-unsubscribe")({
  component: MarketingUnsubscribe,
});
